<template>
  <b-modal title="Payment in progress" 
    v-model="terminalIsRequesting"
    @hidden="cancelCharge"
    class="terminal-modal" 
    no-close-on-backdrop no-close-on-esc hide-footer centered
    size="sm">
      {{terminalMessage}}
  </b-modal>
</template>

<script>
  import { mapState, mapMutations } from "vuex";

  export default {
    name: "TerminalStatusModal",
    computed: {
      ...mapState({
        terminalRequesting: state => state.terminal.terminalRequesting,
        terminalMessage: state => state.terminal.terminalMessage
      }),
      terminalIsRequesting: {
        get(){ return this.terminalRequesting },
        set(val){ console.log('updating')}
      }
    },
    methods: {
      ...mapMutations({
        cancelCharge: 'setToCancelled'
      })
    }
  };
</script>
